import classNames from 'classnames';
import Link from '../../../components/Link';
import PillBox from '../../../components/PillBox';
import { getWithCount } from '../../../services/Pluralize';
import type { NavLink, NavLinkNotification } from './links';
import styles from './style.m.less';

type Props = Pick<
    NavLink,
    | 'title'
    | 'route'
    | 'icon'
    | 'titleClass'
    | 'trackingLabel'
    | 'testId'
    | 'dataIntercomTarget'
    | 'onClick'
    | 'openInNewTab'
> & {
    isCurrent?: boolean;
    isDeactivated?: boolean;
    notification?: NavLinkNotification;
};

export function PureNavLink({
    title,
    route,
    icon,
    isCurrent,
    isDeactivated,
    notification,
    titleClass,
    trackingLabel,
    testId,
    dataIntercomTarget,
    onClick,
    openInNewTab = false,
}: Props) {
    return (
        <li className={styles.liReset}>
            <Link
                href={route}
                hasTextStyle={false}
                eventTracking={{ category: 'navigation sidebar', action: 'click', label: trackingLabel }}
                data-intercom-target={dataIntercomTarget}
                onClick={onClick}
                openInNewTab={openInNewTab}
                testId={testId}
            >
                <div className={classNames(styles.link, { [styles.active]: isCurrent })}>
                    <span className={classNames(styles.icon, { [styles.deactivated]: isDeactivated })}>{icon}</span>
                    <span className={classNames(titleClass, styles.title, { [styles.deactivated]: isDeactivated })}>
                        {title}
                        {notification && notification.count > 0 && (
                            <span
                                className={styles.notification}
                                aria-label={getWithCount('notification', notification.count)}
                            >
                                <PillBox color={notification.color} value={notification.count} />
                            </span>
                        )}
                    </span>
                </div>
            </Link>
        </li>
    );
}
